export default "__VITE_ASSET__Bf3_cOP6__"